import React, { useEffect, useState } from 'react';
import { Line, Bar, ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const PsychProfilerChart = ({data}) => {
  
  const [evolutionData, setEvolutionData] = useState([])


  useEffect(() => {
const result = data.map((item, index) => ({
    assessment: item.total_assessments,
    probability: Math.round(item.probability * 100),
    certainty: Math.round(item.certainty * 100),
    type: item.most_likely_pairing
  }))
    setEvolutionData(result)
  },[data])

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-4 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-semibold text-gray-800">Assessment #{label}</p>
          <p className="text-purple-600">Probability: {payload.find(p => p.dataKey === 'probability')?.value}%</p>
          <p className="text-cyan-600">Certainty: {payload.find(p => p.dataKey === 'certainty')?.value}%</p>
          <p className="text-sm text-gray-600 mt-1">{data.type}</p>
        </div>
      );
    }
    return null;
  };





  return (
    <div className='text-black'>
    <h3 className="text-lg font-semibold mb-4">Psychological Profiler Metrics</h3>
        <div className="h-96">
          <ResponsiveContainer width="100%" height="100%">

            <ComposedChart data={evolutionData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis 
              dataKey="assessment" 
              stroke="#64748b"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <YAxis 
              stroke="#64748b"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar 
              dataKey="certainty" 
              fill="url(#certaintyBarGradient)"
              name="Certainty (%)"
              radius={[2, 2, 0, 0]}
            />
            <Line 
              type="monotone" 
              dataKey="probability" 
              stroke="#8b5cf6" 
              strokeWidth={3}
              dot={{ fill: '#8b5cf6', strokeWidth: 2, r: 5 }}
              name="Probability (%)"
            />
            <defs>
              <linearGradient id="certaintyBarGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#06b6d4" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#06b6d4" stopOpacity={0.4}/>
              </linearGradient>
            </defs>
          </ComposedChart>

          </ResponsiveContainer>
        </div>


      {/* Insights Panel */}
      {/* Key Insights for the data */ }

    </div>
  );
};

export default PsychProfilerChart;

